export default __webpack_public_path__ + "static/media/hacker-rank-2.7968ab82.png";